import AllTicketsSection from '@/components/manage/tickets/sendTickets/AllTicketsSection';
import PassengerSelectionCard from '@/components/manage/tickets/sendTickets/PassengerSelectionCard';
import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { Typography } from '@fleet/webshop-ui';
import { type FC } from 'react';

const SendTicketsToEmailContent: FC = () => {
  const booking = useSelector(manageFlowBookingSelector)!;

  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="flex flex-col gap-2">
        <Typography variant="paragraph">
          <TransText i18nKey="sendAllTicketsTo" />:
        </Typography>
        <AllTicketsSection />
      </div>

      <div className="flex flex-col gap-2">
        <Typography variant="paragraph">
          <TransText i18nKey="sendPassengersOwnTicketsTo" />:
        </Typography>
        <div className="flex flex-col gap-3">
          {(booking.passengers || []).map((bookingPassenger) => (
            <PassengerSelectionCard
              key={bookingPassenger.id}
              bookingPassenger={bookingPassenger}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SendTicketsToEmailContent;
